/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum BatchProcessingStatus {
    NotStarted = 0,
    Running = 100,
    Succeeded = 200,
    PartialSuccess = 300,
    Error = 400,
    Deleted = 500
}

export function BatchProcessingStatusFromJSON(json: any): BatchProcessingStatus {
    return BatchProcessingStatusFromJSONTyped(json, false);
}

export function BatchProcessingStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): BatchProcessingStatus {
    return json as BatchProcessingStatus;
}

export function BatchProcessingStatusToJSON(value?: BatchProcessingStatus | null): any {
    return value as any;
}

